import React, { FC, Fragment, ReactNode } from 'react';

import {
  ContentUrlParamOptions,
  GetContentUrlParamOptionsComponent,
  GetContentUrlParamOptionsQueryVariables,
} from 'api';
import { LoaderTypes } from 'types/app';
import { QueryManager } from 'components';

interface IProps extends GetContentUrlParamOptionsQueryVariables {
  loader?: LoaderTypes;
  url: string;
  children: (preview: ContentUrlParamOptions[]) => ReactNode;
}

const GetContentUrlParamOptions: FC<IProps> = ({ children, loader, url, ...rest }) => {
  if (!url) {
    return <Fragment>{children([])}</Fragment>;
  }

  return (
    <GetContentUrlParamOptionsComponent variables={{ url }} {...rest}>
      {queryResult => (
        <QueryManager loader={loader} {...queryResult}>
          {({ data }) => {
            if (!data?.getContentUrlParamOptions) {
              return children([]);
            }
            return children(data.getContentUrlParamOptions);
          }}
        </QueryManager>
      )}
    </GetContentUrlParamOptionsComponent>
  );
};

export default GetContentUrlParamOptions;
